import React from 'react';

import { AuthComponent } from '@futrli/auth';
import { SSOEmbedProvider } from '@futrli/auth/sso-embed/sso-context';
import { BillingProvider } from '@futrli/billing';
import { ErrorBoundary } from '@futrli/errors';
import { UIPromiseTrackerLoader, ToastProvider } from '@futrli/ui-components';

import { AppLoggedIn } from './app-logged-in';
import { GlobalTracker } from './components/global-tracker';
import { LDProvider } from '../core/providers/launch-darkly/';
import { STRIPE_API_KEY, SESSION_DURATION_MS } from '../core/config';

import { useBirdie } from './useBirdie';

export const AppAuth = () => {
  useBirdie();

  return (
    <div className="main-wrapper">
      <BillingProvider apiKey={STRIPE_API_KEY}>
        <ErrorBoundary>
          <LDProvider>
            <ToastProvider>
              <GlobalTracker />
              <SSOEmbedProvider>
                <AuthComponent component={AppLoggedIn} sessionDurationMs={SESSION_DURATION_MS} />
              </SSOEmbedProvider>
              <UIPromiseTrackerLoader />
            </ToastProvider>
          </LDProvider>
        </ErrorBoundary>
      </BillingProvider>
    </div>
  );
};
